import { field, date, writer, relation,text } from '@nozbe/watermelondb/decorators';
import { INVOICE_PAYMENTS_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class InvoicePayments extends Model {
    static table = INVOICE_PAYMENTS_SCHEMA;

    static associations = {
        invoice: { type: 'belongs_to', foreignKey: 'invoice_id' },
        business: { type: 'belongs_to', key: 'business_id' },
    }

    @field('amount') amount;
    @text('method') method;
    @text('wallet') wallet;
    @text('bank') bank;

    @date('created_at') created_at;

    @relation('business', 'business_id') business;
    @relation('invoice', 'invoice_id') invoice;

    @writer async updateInvPayment(details) {
        await this.update(inv => {
            inv.amount = details.amount
            inv.method = details.method
            inv.bank = details.bank
            inv.wallet = details.wallet
        });
    };
};